import type { ReactNode } from 'react';
import { Check, Paper, artStyle } from './parts';

/** The folder monitor: a watched folder on a computer, its files carried up to Paige by themselves. */
export function FolderArt({ width = 280 }: { width?: number }): ReactNode {
  return (
    <svg
      className="scan-art"
      viewBox="0 0 280 180"
      style={artStyle(width)}
      aria-hidden="true"
      focusable="false"
    >
      <path
        className="sa-shade"
        d="M24 76a8 8 0 0 1 8-8h26l8 9h44a8 8 0 0 1 8 8v58a8 8 0 0 1-8 8H32a8 8 0 0 1-8-8Z"
      />
      <Paper x={40} y={58} r={-6} w={36} h={46} tone={2} />
      <Paper x={58} y={54} r={4} w={36} h={46} tone={0} mark className="sa-float" />
      <path className="sa-body" d="M24 100h94v43a8 8 0 0 1-8 8H32a8 8 0 0 1-8-8Z" />
      <circle className="sa-shade" cx="104" cy="136" r="9" />
      <circle className="sa-body" cx="104" cy="136" r="3.5" />
      <path className="sa-trail" d="M118 92 C 150 40, 176 44, 196 70" />
      <path
        className="sa-body"
        d="M174 116h70a20 20 0 0 0 0-40 28 28 0 0 0-52-8 22 22 0 0 0-18 48Z"
      />
      <Check cx={214} cy={94} r={13} />
    </svg>
  );
}
